/* eslint-disable global-require */
const STORAGE_KEY = "nm_reviews_content";
const REVIEW_IMAGE_01 = require("../review-preview/img/review-01.jpeg");
const REVIEW_IMAGE_02 = require("../review-preview/img/review-02.jpeg");
/* eslint-enable global-require */

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function createId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function getDefaultReviews() {
  return [
    {
      id: "r1",
      date: "08.02.2024",
      user: "Ю.С. Почивалов",
      post: "Генеральный директор АО «ПО «Электроприбор»",
      image: REVIEW_IMAGE_02,
      text: "Спектр нашего сотрудничества с компанией «Новая Марка»: от мелкотиражной полиграфической продукции вплоть до разработки стандартов продаж и корпоративной культуры в компании. Особенно хочется отметить профессионализм, скорость выполнения и качество дизайнерских работ компании «Новая Марка». Именно благодаря тесному сотрудничеству с компанией «Новая Марка» наш фирменный образ – Самурай – ожил и получил новые интересные интерпретации в глазах наших клиентов, а мы получили красивый модернизированный веб-сайт, а также отдельный лендинг по продаже запасных частей для японских автомобилей со скидкой. Не говоря уже о менее интеллектуально емком дизайне (карты, календари, баннеры, флаги, корпоративная одежда и пр.): здесь все тоже было на высшем уровне. Рекомендуем компанию «Новая Марка» как честную команду профессионалов своего дела, имеющих опыт и ресурсы для решения самых сложных задач с клиентом любого типа.",
    },
    {
      id: "r2",
      date: "08.02.2024",
      user: "ГБУЗ «Городская клиническая больница скорой медицинской помощи им. Г.А. Захарьина»",
      post: "Наталья Морозова, заведующая рентгенологическим отделением им. В.В. Милешина, председатель первичной организации Профсоюза ГБУЗ «Городская клиническая больница скорой медицинской помощи им. Г.А. Захарьина»",
      image: REVIEW_IMAGE_01,
      text: "С Новой Маркой мы сотрудничаем уже год. Была у меня идея «фикс» – сделать для своего отделения необычные бейджи с фирменной символикой. Требования были такими: большой размер, износостойкость, магнитное крепление, жесткая основа). Обратилась в «Новую Марку», и они нашли лучшее, на мой взгляд, решение, напечатав бейджи прямо на оргстекле. В итоге, получилось и полноцветно, и крупно, и устойчиво к внешним воздействиям. Как объяснили мне производственники в «Новой Марке», бейджи сделаны по технологии прямой печати по материалу на универсальном сувенирном принтере. В результате, когда сотрудники моего отделения первыми в больнице одели эти бейджи, в «Новую Марку» пошли обращения и от других отделений, желающих взять с нас пример! Хотела бы я сказать, что «Новая Марка» мне еще должна, только вот качество работ меня устраивает, и хороших людей, которые качественно делают свою работу, я готова рекламировать просто так. Да, и еще…спасибо «Новой Марке» за очень нестандартную сувенирную и полиграфическую рекламу в честь празднования 70-летия годовщины Великой Победы. Наш профком вас не забудет!",
    },
    {
      id: "r3",
      date: "08.02.2024",
      user: "Ю.С. Почивалов",
      post: "Генеральный директор АО «ПО «Электроприбор»",
      image: REVIEW_IMAGE_02,
      text: "С компанией «Новая Марка» сотрудничаем уже более 5 лет. За это время компания активно участвовала в оформлении таких значимых для нашего завода объектов, как Доска Почета, входная группа завода, кабинет охраны труда, спорткомплекс «Горизонт».",
    },
    {
      id: "r4",
      date: "08.02.2024",
      user: "Ю.С. Почивалов",
      post: "Генеральный директор АО «ПО «Электроприбор»",
      image: REVIEW_IMAGE_01,
      text: "С компанией «Новая Марка» сотрудничаем уже более 5 лет. За это время компания активно участвовала, кабинет охраны труда, в оформлении таких значимых для нашего завода объектов, как Доска Почета, входная группа завода, входная группа завода, кабинет охраны труда, спорткомплекс «Горизонт».",
    },
    {
      id: "r5",
      date: "08.02.2024",
      user: "Ю.С. Почивалов",
      post: "Ю.С. Почивалов, Генеральный директор АО «ПО «Электроприбор»",
      image: REVIEW_IMAGE_02,
      text: "Благодарность объявляется сотрудникам ООО «Новая марка» в лице директора Калинина Юрия Евгеньевича за активное участие и добросовестный труд в создании музейно-выставочного комплекса АО «ПО «Электроприбор».",
    },
    {
      id: "r6",
      date: "08.02.2024",
      user: "Ю.С. Почивалов",
      post: "Генеральный директор АО «ПО «Электроприбор»",
      image: REVIEW_IMAGE_01,
      text: "С компанией «Новая Марка» сотрудничаем уже более 5 лет. За это время компания активно участвовала в оформлении таких значимых для нашего завода объектов, как Доска Почета, входная группа завода, кабинет охраны труда, спорткомплекс «Горизонт».",
    },
  ];
}

function normalizeReview(item = {}) {
  const user = String(item.user || "").trim();
  const text = String(item.text || item.caption || "").trim();
  if (!user || !text) return null;

  return {
    id: String(item.id || createId()),
    date: String(item.date || "").trim(),
    user,
    post: String(item.post || "").trim(),
    image: String(item.image || "").trim(),
    text,
  };
}

function normalizeData(raw) {
  if (!raw || typeof raw !== "object" || !Array.isArray(raw.reviews)) {
    return { reviews: getDefaultReviews() };
  }

  return {
    reviews: raw.reviews.map((item) => normalizeReview(item)).filter(Boolean),
  };
}

function getReviewsData() {
  const cached = window.NMApi?.cache?.reviews;
  if (cached && Array.isArray(cached.reviews)) return normalizeData(cached);
  return { reviews: getDefaultReviews() };
}

function saveReviewsData(data) {
  const normalized = normalizeData(data);
  if (window.NMApi) {
    window.NMApi.cache.reviews = normalized;
    window.NMApi.save("reviews", normalized).catch((error) => {
      window.alert(error.message || "Не удалось сохранить отзывы"); // eslint-disable-line no-alert
    });
  }
  return normalized;
}

function getReviews() {
  return getReviewsData().reviews;
}

function upsertReview(review) {
  const next = normalizeReview(review);
  if (!next) return getReviewsData();
  const reviews = getReviews();
  const index = reviews.findIndex((item) => item.id === next.id);
  if (index >= 0) reviews[index] = next;
  else reviews.push(next);
  return saveReviewsData({ reviews });
}

function deleteReview(id) {
  return saveReviewsData({
    reviews: getReviews().filter((item) => item.id !== id),
  });
}

function renderPost(review) {
  if (!review.post) return "";
  const imageHref = window.NMSanitize?.safeHref?.(review.image, { allowData: true }) || "";
  if (imageHref) {
    return `<a class="review-preview__post glightbox p1" href="${escapeHtml(imageHref)}" data-gallery="review-${escapeHtml(review.id)}">${escapeHtml(review.post)}</a>`;
  }
  return `<p class="review-preview__post p1">${escapeHtml(review.post)}</p>`;
}

function renderReviewCard(review) {
  const post = renderPost(review);

  return `
    <div class="slide-row__slide swiper-slide">
      <div class="review-preview">
        <div class="review-preview__wrapper">
          <div class="review-preview__date p2">${escapeHtml(review.date)}</div>
          <div class="review-preview__user d2">${escapeHtml(review.user)}</div>
          ${post}
          <div class="review-preview__caption p1">${escapeHtml(review.text)}</div>
          <button class="review-preview__show-more btn-s" type="button" data-review-open="${escapeHtml(review.id)}">
            <span>Полный отзыв</span>
            <svg width="16" height="16" viewBox="0 0 16 16">
              <use xlink:href="#icon-arrow-right-top"></use>
            </svg>
          </button>
        </div>
      </div>
    </div>
  `;
}

function bindReviewOverflow(root) {
  if (!root) return;
  root.querySelectorAll(".review-preview").forEach((card) => {
    const caption = card.querySelector(".review-preview__caption");
    const showMore = card.querySelector(".review-preview__show-more");
    if (!caption || !showMore) return;

    const update = () => {
      showMore.classList.remove("is-show");
      if (caption.scrollHeight > caption.offsetHeight) {
        showMore.classList.add("is-show");
      }
    };

    update();
    window.addEventListener("resize", update);
  });
}

function fillReviewPopup(review) {
  const popup = document.getElementById("popup-review");
  if (!popup || !review) return;

  const date = popup.querySelector(".popup__review-date");
  const user = popup.querySelector(".popup__review-user");
  const post = popup.querySelector(".popup__review-post");
  const caption = popup.querySelector(".popup__review-caption");

  if (date) date.textContent = review.date || "";
  if (user) user.textContent = review.user || "";
  if (post) {
    post.textContent = review.post || "";
    post.hidden = !review.post;
  }
  if (caption) caption.textContent = review.text || "";
}

function updateSwiper(wrapper) {
  const swiperRoot = wrapper?.closest(".swiper");
  if (swiperRoot?.swiper) {
    swiperRoot.swiper.update();
    swiperRoot.swiper.slideTo(0, 0);
  }
}

function hydratePublicReviews() {
  const section = document.querySelector(".reviews-section");
  const wrapper = document.querySelector("[data-home-reviews]");
  if (!wrapper) return;

  const reviews = getReviews();
  if (section) section.hidden = !reviews.length;
  wrapper.innerHTML = reviews.map((item) => renderReviewCard(item)).join("");
  updateSwiper(wrapper);
  bindReviewOverflow(wrapper);

  if (window.lightbox?.reload) {
    window.lightbox.reload();
  }
}

function bindPublicReviews() {
  const wrapper = document.querySelector("[data-home-reviews]");
  if (!wrapper || wrapper.dataset.reviewsBound === "1") return;
  wrapper.dataset.reviewsBound = "1";

  wrapper.addEventListener("click", (event) => {
    const button = event.target.closest("[data-review-open]");
    if (!button) return;
    const review = getReviews().find((item) => item.id === button.getAttribute("data-review-open"));
    if (!review) return;
    fillReviewPopup(review);
    if (typeof window.openPopup === "function") {
      window.openPopup("popup-review");
    }
  });
}

window.NMReviewsContent = {
  STORAGE_KEY,
  createId,
  escapeHtml,
  getDefaultReviews,
  normalizeReview,
  normalizeData,
  getReviewsData,
  saveReviewsData,
  getReviews,
  upsertReview,
  deleteReview,
  hydratePublicReviews,
};

bindPublicReviews();
window.NMApi?.ready?.then(hydratePublicReviews);
